import { useQueryClient } from "@tanstack/react-query";

export default useQueryClient;
